// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;

const LoadingBox = props => {
	const {isOverlay = false, message} = props;

	const loading = (
		<div className="aa-loading-box">
			<div className="aa-animation">
				<div className="aa-animation-item aa-animation-item-1" />
				<div className="aa-animation-item aa-animation-item-2" />
				<div className="aa-animation-item aa-animation-item-3" />
				<div className="aa-animation-item aa-animation-item-4" />
			</div>
			{message && (<span>{message}</span>)}
		</div>
	);

	if (!isOverlay)
		return loading;

	return (
		<div className="aa-loading-box-overlay">
			{loading}
		</div>
	);
};

export default LoadingBox;
